<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="productionOrders"
        :sel-reset="true"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
        @select="selectHandle"
    >
      <template slot="otherBtn">
        <el-button v-if="limits.dispatchAuth" type="primary" :disabled="!selection.length" @click="dispatchHandle"> 工单派工 </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工单编号">
            <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入工单编号" clearable/>
          </el-form-item>
          <el-form-item label="工单类型">
            <el-select v-model="filter.productionOrderType" placeholder="请选择工单类型" clearable>
              <el-option label="销售订单" :value="1"/>
              <el-option label="自制工单" :value="2"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料规格">
            <el-input v-model.trim="filter.materialSpecification" placeholder="请输入物料规格" clearable/>
          </el-form-item>
          <el-form-item label="派工状态">
            <el-select v-model="filter.status" placeholder="请选择派工状态" clearable>
              <el-option label="待派工" :value="10"/>
              <el-option label="派工中" :value="20"/>
              <el-option label="已派工" :value="30"/>
              <el-option label="全部" :value="40"/>
            </el-select>
          </el-form-item>
          <el-form-item label="工艺路线">
            <el-input v-model.trim="filter.routingName" placeholder="请输入工艺路线名称" clearable/>
          </el-form-item>
          <el-form-item label="销售单号">
            <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入销售订单编号" clearable/>
          </el-form-item>
          <el-form-item label="合同号" label-width="64px">
            <el-input v-model.trim="filter.customerContractNo" placeholder="请输入合同号" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
          <el-form-item label="开工日期">
            <el-date-picker
                v-model="startDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="startDateChange"
            />
          </el-form-item>
          <el-form-item label="完工日期">
            <el-date-picker
                v-model="finishDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="finishDateChange"
            />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <production-plan-edit ref="productionPlanEdit" @save-success="loadData"/>
    <dispatch-edit ref="dispatchEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ProductionPlanEdit from "./ProductionPlanEdit";
  import DispatchEdit from "./DispatchEdit";
  export default {
    components: { viewTable, ProductionPlanEdit, DispatchEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(163),
          editAuth: this.$auth(164),
          delAuth: this.$auth(165),
          dispatchAuth: this.$auth(166),
        },
        filter: {
          productionOrderNo: "",
          productionOrderType: "",
          materialName: "",
          materialNo: "",
          materialSpecification: "",
          status: "",
          routingName: "",
          salesOrderNo: "",
          customerContractNo: "",
          customerName: "",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "productionOrderNo",
            width: 140,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.productionPlanEdit.open(params.row, true);
                    },
                  },
                },
                params.row.productionOrderNo
              );
            },
          },
          {
          tooltip: true,
            key: "prodOrderTypeName",
            width: 100,
            align: "center",
          },
          {
          tooltip: true,
            key: "materialNo",
            width: 160,
          },
          {
            key: "materialName",
            minWidth: 360,
            tooltip: true,
          },
          {
            key: "specification",
            width: 220,
            tooltip: true,
          },
          {
          tooltip: true,
            key: "statusName",
            width: 90,
            align: "center",
          },
          {
          tooltip: true,
            key: "materialHeight",
            width: 100,
            align: "center",
          },
          {
          tooltip: true,
            key: "materialWidth",
            width: 90,
            align: "center",
          },
          {
          tooltip: true,
            key: "materialLength",
            width: 90,
            align: "center",
          },
          {
          tooltip: true,
            key: "materialWeight",
            width: 90,
            align: "center",
          },
          {
            key: "routingName",
            width: 150,
            tooltip: true,
          },
          {
          tooltip: true,
            key: "quantity",
            width: 100,
            align: "center",
          },
          {
          tooltip: true,
            key: "leftQuantity",
            width: 110,
            align: "center",
          },
          {
          tooltip: true,
            key: "unit",
            width: 80,
            align: "center",
          },
          {
          tooltip: true,
            key: "planStartTime",
            width: 160,
            align: "center",
          },
          {
          tooltip: true,
            key: "planFinishTime",
            width: 160,
            align: "center",
          },
          {
          tooltip: true,
            key: "salesOrderNo",
            width: 150,
            align: "center",
          },
          {
          tooltip: true,
            key: "customerContractNo",
            width: 150,
            align: "center",
          },
          {
            key: "customerName",
            width: 220,
            tooltip: true,
          },
          {
            key: "projectName",
            width: 220,
            tooltip: true,
          },
          {
          tooltip: true,
            key: "deliveryDate",
            width: 120,
            align: "center",
          },
          {
            key: "salesOrderMaterialNote",
            width: 220,
            tooltip: true,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        startDate: "", // 开工日期
        finishDate: "", // 完工日期
        selection: [],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.productionPlanEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "productionOrders", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      startDateChange(value) {
        if (value) {
          this.filter.planStartFrom = value[0];
          this.filter.planStartTo = value[1];
        } else {
          this.filter.planStartFrom = "";
          this.filter.planStartTo = "";
        }
      },

      finishDateChange(value) {
        if (value) {
          this.filter.planFinishFrom = value[0];
          this.filter.planFinishTo = value[1];
        } else {
          this.filter.planFinishFrom = "";
          this.filter.planFinishTo = "";
        }
      },

      // 待派工的可以编辑 删除
      otherAuth(row) {
        return row.status !== 10 || row.creatorId === -1;
      },

      resetHandle(filter) {
        this.filter = filter;
        this.startDate = "";
        this.finishDate = "";
      },

      dispatchHandle() {
        if (this.selection.length > 1) {
          this.$confirm("请选择一条工单", "错位", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$refs.dispatchEdit.open(this.selection[0].pkid);
        }
      },
    },
  };
</script>
